/**
 * Vendor Import — Mapping review group accordion.
 *
 * A collapsible group heading used once per review category (Mapped /
 * Will create / Skipped). Renders a bordered accordion item with a
 * title + count header; expansion is owned by the parent <Accordion>.
 */

import React from 'react';

import {
  AccordionChevron,
  AccordionItem,
  AccordionPanel,
  AccordionTrigger,
} from '@/lib/base/accordion';

interface MappingReviewGroupProps {
  id: string;
  title: string;
  count: number;
  children: React.ReactNode;
}

function MappingReviewGroupComponent({
  id,
  title,
  count,
  children,
}: MappingReviewGroupProps) {
  return (
    <AccordionItem
      id={id}
      aria-label={`${title}, ${count}`}
      className='border border-[var(--color-border-secondary)] rounded-lg overflow-hidden'
    >
      <AccordionTrigger className='w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-[var(--color-bg-secondary)]'>
        <AccordionChevron variant='leading' />
        <span className='flex-1 text-sm font-medium text-primary'>{title}</span>
        <span className='text-sm font-semibold tabular-nums text-tertiary'>
          {count}
        </span>
      </AccordionTrigger>
      <AccordionPanel className='border-t border-[var(--color-border-secondary)] flex flex-col gap-4 p-4'>
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
}

export const MappingReviewGroup = React.memo(MappingReviewGroupComponent);
